import { Browser } from './browser';
import { Features } from './features';
import { EnvironmentInfo } from './models';
import { OS } from './OS';

export const Environment: EnvironmentInfo = (function (): EnvironmentInfo {
    const env: EnvironmentInfo = <unknown>{
        OS: {...OS, version: {...OS.version}},
        Features: {...Features},
        Browser: {...Browser, version: {...Browser.version}},
    };

    const osEntry = Object.entries(env.OS).filter(([name, value]) => {
        return value === true;
    });

    if (osEntry?.length > 0) {
        env.OsName = osEntry.pop()[0];
    }

    const browserEntry = Object.entries(env.Browser).filter(([name, value]) => {
        return value === true;
    });
    if (browserEntry?.length > 0) {
        env.BrowserName = browserEntry.pop()[0];
    }

    return env;
}());
